// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountSearchController from "./account_search_controller"
application.register("account-search", AccountSearchController)

import AccountSelectController from "./account_select_controller"
application.register("account-select", AccountSelectController)

import CampaignRedeemableScopeController from "./campaign_redeemable_scope_controller"
application.register("campaign-redeemable-scope", CampaignRedeemableScopeController)

import ChargingTypeFormController from "./charging_type_form_controller"
application.register("charging-type-form", ChargingTypeFormController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CreditsOverviewChartController from "./credits_overview_chart_controller"
application.register("credits-overview-chart", CreditsOverviewChartController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DropdownCloseController from "./dropdown_close_controller"
application.register("dropdown-close", DropdownCloseController)

import LocationController from "./location_controller"
application.register("location", LocationController)

import MapController from "./map_controller"
application.register("map", MapController)

import PeakHoursChartController from "./peak_hours_chart_controller"
application.register("peak-hours-chart", PeakHoursChartController)

import UsageByDaysChartController from "./usage_by_days_chart_controller"
application.register("usage-by-days-chart", UsageByDaysChartController)

import UsageByMembersChartController from "./usage_by_members_chart_controller"
application.register("usage-by-members-chart", UsageByMembersChartController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import ToastTriggerController from "./toast_trigger_controller"
application.register("toast-trigger", ToastTriggerController)

import TopUsersChartController from "./top_users_chart_controller"
application.register("top-users-chart", TopUsersChartController)

import VisitsChartController from "./visits_chart_controller"
application.register("visits-chart", VisitsChartController)

import WebauthnCredentialsController from "./webauthn_credentials_controller"
application.register("webauthn-credentials", WebauthnCredentialsController)

import PromoCarouselController from "./promo_carousel_controller"
application.register("promo-carousel", PromoCarouselController)

import TouchFeedbackController from "./touch_feedback_controller"
application.register("touch-feedback", TouchFeedbackController)

import VisitDetailSheetController from "./visit_detail_sheet_controller"
application.register("visit-detail-sheet", VisitDetailSheetController)

import LiveDurationController from "./live_duration_controller"
application.register("live-duration", LiveDurationController)
